import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import RequireAuth from '../../components/RequireAuth';

import { useAppData } from '../../core/context/AppDataContext';
import { ReportType } from '../../core/api/clients';
import { AuthorizedFormDataProvider } from '../../core/context/AuthorizedFormDataContext';

import LoadingOverlay from '../../components/LoadingOverlay';
import IncidentFormLayout from './IncidentFormLayout';
import IncidentFormEdit from './IncidentFormEdit';
import IncidentFormView from './IncidentFormView';
import IncidentFormHome from './IncidentFormHome';
import IncidentAuditLogs from './IncidentAuditLogs';
import useTitle from '../../core/api/hooks/common/useTitle';

function IncidentEventContainer() {
  const { authorizedForms, getFormByName } = useAppData();
  useTitle(document.documentURI);
  if (authorizedForms !== undefined) {
    const form = getFormByName(ReportType.Incident);

    if (form !== undefined) {
      const { isAdministrator, isReader } = form;

      const canEdit = (isAdministrator);
      const canView = (isReader || isAdministrator);

      return (
        <AuthorizedFormDataProvider authorizedFormData={form}>
          <Routes>
            <Route path=":formId" element={<IncidentFormLayout />}>
              <Route
                path="edit"
                element={(
                  <RequireAuth isAuthorized={(canEdit) ?? false}>
                    <IncidentFormEdit />
                  </RequireAuth>
                )}
              />
              <Route
                path="logs"
                element={(
                  <RequireAuth isAuthorized={(canView) ?? false}>
                    <IncidentAuditLogs />
                  </RequireAuth>
                )}
              />
              <Route
                path=":action"
                element={(
                  <RequireAuth
                    isAuthorized={(canView) ?? false}
                  >
                    <IncidentFormView />
                  </RequireAuth>
                )}
              />
            </Route>
            <Route
              index
              element={(
                <IncidentFormHome />
              )}
            />
          </Routes>
        </AuthorizedFormDataProvider>
      );
    }

    return (
      <span>Not Authorized</span>
    );
  }

  return (
    <LoadingOverlay />
  );
}

export default IncidentEventContainer;
